import { render, staticRenderFns } from "./ModifiedMultiselect.vue?vue&type=template&id=e4d744b2&"
import script from "./ModifiedMultiselect.vue?vue&type=script&lang=js&"
export * from "./ModifiedMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./ModifiedMultiselect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports